import React from "react";
import CrudTasasAdmin from "./CrudTasasAdmin";

const competenciaOptions = [
    { value: "payway", label: "Payway" },
    { value: "mercadopago", label: "Mercado Pago" },
    { value: "naranjax", label: "Naranja X" },
    { value: "getnet", label: "Getnet" },
    { value: "viumi", label: "Viumi" },
    { value: "nave", label: "Nave" },
];

const tipoPagoOptions = [
    { value: "debito", label: "Debito" },
    { value: "credito", label: "Credito" },
];

// Vacía = la tasa aplica a todas las tarjetas. Una fila con tarjeta pisa a la general
// para esa tarjeta en el comparador. Los valores coinciden con las columnas de Tasas Zoco.
const tarjetaOptions = [
    { value: "", label: "Todas" },
    { value: "visa", label: "Visa" },
    { value: "mastercard", label: "Mastercard" },
    { value: "american express", label: "American Express" },
    { value: "argencard", label: "Argencard" },
    { value: "cabal", label: "Cabal" },
    { value: "naranja", label: "Naranja" },
];

const fields = [
    { key: "competencia", label: "Competencia", type: "select", options: competenciaOptions, required: true, defaultValue: "payway" },
    { key: "tipoPago", label: "Tipo pago", type: "select", options: tipoPagoOptions, required: true, defaultValue: "debito" },
    { key: "cuota", label: "Cuota", type: "number", required: true, defaultValue: 0, decimals: 0, step: "1" },
    { key: "tarjeta", label: "Tarjeta", type: "select", options: tarjetaOptions, defaultValue: "" },
    { key: "arancelPct", label: "Arancel %", type: "number", required: true, defaultValue: 0, decimals: 2 },
    { key: "ivaPct", label: "IVA %", type: "number", required: true, defaultValue: 21, decimals: 2 },
    { key: "impuestoDebCredPct", label: "Imp. Deb/Cred %", type: "number", required: true, defaultValue: 0, decimals: 2 },
    { key: "costoFinancieroPct", label: "Costo financiero %", type: "number", required: true, defaultValue: 0, decimals: 2 },
    { key: "costoAnticipoPct", label: "Costo anticipo %", type: "number", required: true, defaultValue: 0, decimals: 2 },
    { key: "costoMensualTerminal", label: "Costo mensual", type: "number", required: true, defaultValue: 0, decimals: 2 },
    { key: "activo", label: "Activo", type: "checkbox", defaultValue: true },
];

const TablaTasasCompetenciaAdmin = () => {
    return (
        <CrudTasasAdmin
            endpointBase={process.env.REACT_APP_API_TASAS_COMPETENCIA}
            entityLabelSingular="tasa de competencia"
            entityLabelPlural="Tasas de competencia"
            searchPlaceholder="Buscar por competencia, tipo de pago o cuota"
            fields={fields}
            showIdColumn={false}
        />
    );
};

export default TablaTasasCompetenciaAdmin;
